export default __webpack_public_path__ + "static/media/image4.528aebf0.png";